








































import { Vue, Component } from 'vue-property-decorator';
import PasswordForm from './forms/password.vue';
import SecondFactorForm from './forms/second-factor.vue';
import ApiKeysForm from './forms/apikeys.vue';
import LatestSessionsForm from './forms/latest-sessions.vue';
import LandingProtectionForm from './forms/landing-protection.vue';
import api, { SecuritylApi } from './api';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component({
  components: {
    PasswordForm,
    SecondFactorForm,
    ApiKeysForm,
    LatestSessionsForm,
    LandingProtectionForm
  }
})
export default class GeneralSettings extends mixins(PlanLimitsMixin) {
  api: SecuritylApi = api;

  load(): any {
    const apiKeys: Promise<any> = this.api.getApiKeys();
    const sessions: Promise<any> = this.api.getSessions();
    let landingSecretKey = null;
    if(!this.hasPlanLimitsRestriction('landingPageProtection')){
      landingSecretKey = this.api.getLandingSecretKey();
    }

    return Promise.all([apiKeys, sessions, landingSecretKey])
  }

  mounted() {
    this.$store.commit('loading', true);
    this.load().finally(() => {
      this.$store.commit('loading', false);
    });
  }
}
